import React, { useEffect, useState } from "react";
import ContentForm, { ContentFormField } from "../../common/forms/ContentForm";
import { RequestState } from "../../utils/RequestState";
import { FieldState, ValType } from "../../utils/ValidationFunctions";
import { postContact } from "../../services/api/user/postContact";
import { ContactCategory } from "../../utils/ContactCategory";
import BtnImg from "../../assets/img/facility/facility-event-contact.webp";
import BtnImgHover from "../../assets/img/facility/facility-event-contact-on.webp";
import styles from "./ContactBanner.module.scss";

type Props = {
  facilityName: string;
};

const FacilityContact: React.FC<Props> = ({ facilityName }) => {
  const facilityContactFields: Array<ContentFormField> = [
    {
      id: "name",
      name: "sonic_name",
      label: "お名前",
      type: "text",
      required: true,
      valType: ValType.NotNull,
    },
    {
      id: "email",
      name: "sonic_email",
      label: "メールアドレス",
      type: "text",
      required: true,
      valType: ValType.NotNull,
    },
    {
      id: "message",
      name: "sonic_message",
      label: "お問い合わせ内容",
      type: "textarea",
      required: true,
      rows: 5,
      valType: ValType.NotNull,
    },
  ];

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const handleSubmit = async (fieldState: FieldState) => {
    const args: { [key: string]: string } = {};
    const checkKeys = facilityContactFields.map((f) =>
      f.name.replace("sonic_", "")
    );
    let error = false;

    for (const [key, value] of Object.entries(fieldState)) {
      const key_name = key.replace("sonic_", "");

      if (!checkKeys.includes(key_name)) {
        error = true;
        break;
      }

      if (!value[0] || typeof value[0] !== "string") {
        error = true;
        break;
      }

      args[key_name] = value[0];
    }

    if (error) {
      return;
    }

    setRequestState(RequestState.Doing);
    const res = await postContact(
      args.name,
      args.email,
      ContactCategory.Others,
      `${args.message}\n\n\n\nお問い合わせ施設URL: ${location.origin}${location.pathname}`
    );

    if (res) {
      setRequestState(RequestState.Success);
    } else {
      setRequestState(RequestState.Failed);
    }
  };

  const handleClose = () => {
    const current = requestState;

    if (current === RequestState.Failed) {
      setRequestState(RequestState.Waiting);
    }

    return setIsOpen(false);
  };

  useEffect(() => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = isOpen ? "hidden" : "unset";
    }

    return () => {
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, [isOpen]);

  return (
    <div>
      <button
        type="button"
        style={{ color: "white" }}
        onClick={() => setIsOpen(true)}
        className={styles["contact-banner-link"]}
      >
        <picture>
          <img src={BtnImg} alt="イベント開催希望はこちら" />
          <img src={BtnImgHover} alt="イベント開催希望はこちら" />
        </picture>
      </button>

      {isOpen ? (
        <ContentForm
          headTitle="イベント開催ご相談フォーム"
          bodyTitle={{ label: "施設名", value: facilityName }}
          requiredFields={facilityContactFields}
          requestState={requestState}
          submitHandler={handleSubmit}
          closeHandler={handleClose}
          successMessage={`お問い合わせいただきありがとうございます。\n後ほど担当者よりご連絡させていただきますので、今しばらくお待ちください。`}
          subSuccessMessage={`※数日お時間を頂戴する場合がございます。\n予めご了承くださいますようお願いいたします。`}
          privacyPolicyCheck={true}
        />
      ) : null}
    </div>
  );
};

export default FacilityContact;
